import(/* webpackMode: "eager" */ "/tmp/8deb9ccd66ffb00/app/[locale]/error.tsx");
